import { render, staticRenderFns } from "./PageContentEditor.vue?vue&type=template&id=0bef95c1&"
import script from "./PageContentEditor.vue?vue&type=script&lang=js&"
export * from "./PageContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageContentEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports